import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  type ApprovalInputArguments,
  optimisticApprovalConfiguration,
} from './helpers'

export const useUnApproveBranch = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      branchKey,
      changesetKey,
      operationKeys,
    }: ApprovalInputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostUnapproveBranch(
        {
          requestBody: {
            _type: 'ApproveBranchSpecification',
            branchName: branchKey.name,
            componentName: branchKey.server.toLocaleLowerCase(),
            changesetKey,
            operationKeys,
          },
        },
      )
    },
    ...optimisticApprovalConfiguration({
      optimisticUserId: undefined,
      isApproval: false,
      queryClient,
    }),
  })
}
